import { AnalysisMalariaReport } from '../../../models/analysis-malaria-report'
import {
  IDiagnosticImage,
  IDiagnosticImageWithAnalysis,
} from '../../../types/diagnostic-image'
import { AnalysisTypeEnum, IAnalysisMalaria } from '../../../types/ia-analysis'
import AnalysisMalariaResultsCard from '../../AnalysisMalariaResultsCard'
import AiReportToPrint from '../../ReportToPrint/components/AiReportToPrint'

interface AnalysisComponentFactoryProps {
  diagnosticImages: IDiagnosticImage[]
  isToPrint?: boolean
}

const AnalysisComponentFactory = ({
  diagnosticImages,
  isToPrint,
}: AnalysisComponentFactoryProps) => {
  const analysisTypeName = diagnosticImages[0].analysisType
  if (!analysisTypeName) {
    return <div>Unknown analysis type</div>
  }

  let component
  switch (analysisTypeName) {
    case AnalysisTypeEnum.MALARIA:
      const malariaReport = new AnalysisMalariaReport(
        diagnosticImages as IDiagnosticImageWithAnalysis<IAnalysisMalaria>[]
      )

      component = isToPrint ? (
        <AiReportToPrint analysisMalariaReport={malariaReport} />
      ) : (
        <AnalysisMalariaResultsCard analysisMalariaReport={malariaReport} />
      )
      break
      
    default:
      component = <div>Unknown analysis type</div>
      break
  }

  return component
}

export default AnalysisComponentFactory
